import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
  type?: "Delete" | "Normal" | undefined;
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, type, ...other } = props;

  return (
    <DialogTitle
      sx={{
        m: 0,
        p: 2,
        ...(type === "Delete" && { backgroundColor: "#E71A19" }),
        ...(type === "Normal" && { backgroundColor: (theme) => theme.palette.primary.main }),
        color: (theme) => type === "Delete" ? theme.palette.grey[300] : "#FFF",
        textAlign: "center",
      }}
      {...other}
    >
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[300],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export interface ConfirmDialogProps {
  visible: boolean;
  headerTitle?: string;
  headerType?: "Delete" | "Normal";
  onOk?: () => void;
  onCancel?: () => void;
  children?: React.ReactNode;
  showCancelBtn?: boolean;
  showIcon?: boolean;
  type?: "Delete" | "Normal" | undefined;
  textAlign?: "left" | "center";
}

export const ConfirmDialog = (props: ConfirmDialogProps) => {
  const { visible, onCancel, onOk, headerTitle, headerType = "Delete", children, showCancelBtn = true, showIcon, type, textAlign = "center" } =
    props;

  const handleClose = React.useCallback(() => {
    onCancel && onCancel();
  }, [onCancel]);

  const handleOk = React.useCallback(() => {
    onOk && onOk();
  }, [onOk]);

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={visible}
      >
        {headerTitle && (
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
            type={headerType}
          >
            {headerTitle}
          </BootstrapDialogTitle>
        )}
        <DialogContent dividers sx={{ textAlign }}>
          {showIcon && (
            <>
              <WarningIcon
                aria-label="warning"
                sx={{
                  color: "#E71A19",
                  fontSize: 40,
                }}
              />
            </>
          )}
          {children}
        </DialogContent>
        <DialogActions
          sx={{
            alignSelf: "center",
          }}
        >
          {showCancelBtn && <Button
            onClick={handleClose}
            sx={{
              backgroundColor: "#555",
              color: "#FFF",
              ":hover": { color: "#000" },
            }}
          >
            キャンセル
          </Button>
          }
          <Button
            className="custom-delete-btn"
            onClick={handleOk}
            sx={{
              color: "#FFF",
              ":hover": { color: "#000" },
              ...(type === "Delete"
                ? {
                  backgroundColor: "#E71A19",
                }
                : {
                  backgroundColor: (theme) => theme.palette.primary.main,
                }),
            }}
          >
            {(type === "Delete" && "削除") || "OK"}
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};
